module.exports = __webpack_public_path__ + "static/media/contact-send.8b8c8aa8.svg";